import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useForm, Controller } from 'react-hook-form';
import { joiResolver } from '@hookform/resolvers/joi';
import Joi from 'joi';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { SFPalette } from '@/lib/color';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import TopBackButton from '@/component/common/top-back-button';
import { fontWeight } from '@/theme';
import SFCheckbox from '@/component/common/sf-checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import SFAlertDialog from '@/component/common/sf-alert-dialog';
import PasswordTextField from '@/component/common/password-textfield';
import { withdrawalUser } from '@/api/server/user/delete';
import { localDeleteStorage } from '@/lib/storage';
import ErrorRes from '@/api/server/ErrorRes';
import BottomFix from '@/component/common/bottom-fix';
import { useTranslation } from 'react-i18next';

type FormDataType = {
  password: string;
};

const schema = Joi.object({
  password: Joi.string()
    .pattern(new RegExp('^(?=.*[a-z])(?=.*\\d)(?=.*[@$!%*?&])[A-Za-z\\d@$!%*?&]{8,16}$'))
    .required(),
});

export default function AccountDelete() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm<FormDataType>({
    resolver: joiResolver(schema),
    mode: 'onChange',
  });

  const [openDialog, setOpenDialog] = useState(false);

  const onSubmit = async (data: FormDataType) => {
    // Add the code here to handle the account deletion
    const re = await withdrawalUser(data.password);
    localDeleteStorage('auth');
    localDeleteStorage('login');
    setOpenDialog(true);
  };

  return (
    <Container maxWidth="sm">
      <TopBackButton
        title={t('title.membershipWithdrawal')}
        boxProps={{
          mb: 4,
        }}
      />
      <Box bgcolor={SFPalette.lightGrey3} p={3} borderRadius={2} mb={3}>
        <Typography
          variant="body1"
          fontWeight={fontWeight.Medium}
          sx={{
            color: SFPalette.grey2,
            wordBreak: 'keep-all',
          }}
        >
          {t('message.applywithdrawal')}
          {/* <br />
          남아있는 자산이 있을 경우 아래 규정에 따라 처리됩니다. */}
        </Typography>
      </Box>
      <FormControlLabel
        sx={{
          mb: 3,
        }}
        control={<SFCheckbox name="allMandatory" />}
        label={
          <Typography variant="body1" ml={1}>
            <strong>{t('message.agreeCheck')}</strong>
          </Typography>
        }
      />
      <form onSubmit={handleSubmit(onSubmit)}>
        <Controller
          name="password"
          control={control}
          defaultValue=""
          render={({ field }) => (
            <div>
              <Typography
                variant="body1"
                fontWeight={fontWeight.Medium}
                sx={{
                  color: SFPalette.grey2,
                  wordBreak: 'keep-all',
                }}
                mb={1}
              >
                {t('message.checkyourPw')}
              </Typography>
              <PasswordTextField {...field} fullWidth placeholder="비밀번호 입력" error={!!errors.password} />
            </div>
          )}
        />

        <BottomFix>
          <Button
            variant="contained"
            type="submit"
            disabled={Object.keys(errors).length !== 0}
            size="large"
            fullWidth
            sx={{
              my: 2,
            }}
            onClick={() => {
              // setOpenDialog(true);
            }}
          >
            {t('button.Withdrawal')}
          </Button>
        </BottomFix>
      </form>
      <SFAlertDialog
        open={openDialog}
        onClose={() => {
          setOpenDialog(false);
          navigate('/signInSns');
        }}
        fullWidth
      >
        {t('message.completedWithdrawal')}
      </SFAlertDialog>
    </Container>
  );
}
